import { render, staticRenderFns } from "./testNotice.vue?vue&type=template&id=069ff066&scoped=true&"
import script from "./testNotice.vue?vue&type=script&lang=js&"
export * from "./testNotice.vue?vue&type=script&lang=js&"
import style0 from "./testNotice.vue?vue&type=style&index=0&id=069ff066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ff066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069ff066')) {
      api.createRecord('069ff066', component.options)
    } else {
      api.reload('069ff066', component.options)
    }
    module.hot.accept("./testNotice.vue?vue&type=template&id=069ff066&scoped=true&", function () {
      api.rerender('069ff066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/testNotice.vue"
export default component.exports